import { PERFORM_LOGIN } from '../actions/action-types';
import { UserWhoami } from '../api/types';
import { performLoginAction } from '../actions';
import { cloneDeep } from 'lodash';
import { empty_user } from '../api';

export interface LoginState {
  logged_in: boolean,
  user: UserWhoami
}

export function loginReducer(state: LoginState = { logged_in: false, user: cloneDeep(empty_user) },
  action: performLoginAction) {
  if (action.type == PERFORM_LOGIN) {
    return Object.assign({}, state, {
      logged_in: true,
      user: action.user
    });
  } else {
    return state;
  }
}
